import type { User } from 'firebase/auth';

type AuthUser = Pick<User, 'emailVerified' | 'providerData'>;

export const PASSWORD_PROVIDER_ID = 'password';
export const TRUSTED_PROVIDER_IDS = new Set(['google.com', 'apple.com']);

export function hasAuthProvider(user: Pick<AuthUser, 'providerData'>, providerId: string): boolean {
  return user.providerData.some((provider) => provider.providerId === providerId);
}

export function hasPasswordProvider(user: Pick<AuthUser, 'providerData'>): boolean {
  return hasAuthProvider(user, PASSWORD_PROVIDER_ID);
}

export function hasTrustedAuthProvider(user: Pick<AuthUser, 'providerData'>): boolean {
  return user.providerData.some((provider) => TRUSTED_PROVIDER_IDS.has(provider.providerId));
}

/**
 * Only Google and Apple identities are trusted without Firebase email verification.
 * Unknown or temporarily empty provider data fails closed until Firebase reports a
 * verified email.
 */
export function requiresEmailVerification(user: AuthUser): boolean {
  return !user.emailVerified && !hasTrustedAuthProvider(user);
}
